import {useLinkToolbarButton, useLinkToolbarButtonState} from "@udecode/plate-link/react";
import {ButtonWrapper} from "./_Button";
import FontAwesome from "../../../utilities/FontAwesome";

export const LinkButton = props => {
    const state = useLinkToolbarButtonState();
    const { props: buttonProps } = useLinkToolbarButton(state);

    return (
        <ButtonWrapper
            tooltip={"Add Link"}
            {...buttonProps}
        >
            <FontAwesome prefix={"fas"} name={"fa-link"} />
        </ButtonWrapper>
    );
};